import { render, staticRenderFns } from "./MypageLinkListParts.vue?vue&type=template&id=ba4dc3b8&scoped=true"
import script from "./MypageLinkListParts.vue?vue&type=script&lang=ts"
export * from "./MypageLinkListParts.vue?vue&type=script&lang=ts"
import style0 from "./MypageLinkListParts.vue?vue&type=style&index=0&id=ba4dc3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4dc3b8",
  null
  
)

export default component.exports